import { StringUtils } from '@grandvisionhq/utils';

const DAY_IN_MS = 24 * 60 * 60 * 1000;
const DAY_NAMES = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
];
const getDayName = (date)=>{
    let day;
    const dayOfWeek = new Date(date).getDay() - 1;
    if (dayOfWeek < 0) {
        day = DAY_NAMES[DAY_NAMES.length - 1];
    } else {
        day = DAY_NAMES[dayOfWeek];
    }
    return `https://schema.org/${StringUtils.upFirst(day)}`;
};
const getSpecialOpeningHours = (specialOpeningHours)=>{
    let i1 = 0;
    return [
        ...specialOpeningHours
    ].sort((a, b)=>Date.parse(a.dateOpenClosed) - Date.parse(b.dateOpenClosed)
    ).reduce((acc, item)=>{
        const current = acc[i1];
        const a = current ? Date.parse(current[current.length - 1].dateOpenClosed) : 0;
        const b = Date.parse(item.dateOpenClosed);
        // if the item is not on a consecutive day to the previous item, put it in a new array.
        if (current && b - a > DAY_IN_MS) {
            i1++;
        }
        // if the item's openClosed is not the same as the previous item or any of
        // the openClosedTime entries differs from the previous item, put it in a new array.
        if (current && current.length > 0) {
            if (current[0].openClosed !== item.openClosed) {
                i1++;
            } else if (current[0].openClosedTime && item.openClosedTime) {
                const sameOpenClosedTime = current[0].openClosedTime.every((time, i)=>{
                    if (!item.openClosedTime || !item.openClosedTime[i]) {
                        return false;
                    }
                    return time.open === item.openClosedTime[i].open && time.close === item.openClosedTime[i].close;
                });
                if (!sameOpenClosedTime) {
                    i1++;
                }
            }
        }
        if (!acc[i1]) {
            acc[i1] = [];
        }
        acc[i1].push(item);
        return acc;
    }, []).reduce((acc, period)=>{
        const first = period[0];
        const last = period[period.length - 1];
        const dayOfWeek = period.length > 1 ? period.map((day)=>getDayName(day.dateOpenClosed)
        ) : getDayName(first.dateOpenClosed);
        let opens = '00:00';
        let closes = '00:00';
        if (first.openClosed === 'OPEN' && first.openClosedTime) {
            opens = first.openClosedTime[0].open;
            closes = first.openClosedTime[0].close;
        }
        acc.push({
            '@type': 'OpeningHoursSpecification',
            dayOfWeek,
            opens,
            closes,
            validFrom: first.dateOpenClosed,
            validThrough: last.dateOpenClosed
        });
        return acc;
    }, []);
};

export { getSpecialOpeningHours };
//# sourceMappingURL=get-special-opening-hours.js.map
